import { useMutation } from "@apollo/client/react";
import { toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { DELETE_VISITA } from "../../../data/graphQL/mutations/Visitas/deleteVisita";
import { useState } from "react";

export const useActions = (handleSearch, visitasProgramadas, periodo, tieneGeoHabilitada) => {
  const NuevaVisitaPath = "/misVisitas/nuevaVisita";
  const navigate = useNavigate();

  const [openConfirmDelete, setOpenConfirmDelete] = useState({ row: null, open: false });

  const [deleteVisita, { loading: deleteVisitaLoading }] = useMutation(DELETE_VISITA, { fetchPolicy: 'no-cache' });

  const handleClickView = (row) => {
    navigate(`${NuevaVisitaPath}`, {
      state: {
        isNew: false,
        onlyView: true,
        idVisita: row?.idVisita,
        idPaciente: row?.idPaciente,
        idProfesional: row?.idProfesional,
        idTipoProfesional: row?.idTipoProfesional,
        idFiguraProfesional: row?.idFiguraProfesional,
        figuraProfesional: row?.figuraProfesional,
        idFuncionProfesional: row?.idProfesionalNavigation?.idFuncion,
        idEvaluacion: row?.idEvaluacion,
        idTipoModulo: row?.idTipoModulo,
        idFrecuencia: row?.idFrecuencia,
        programa: row?.programa,
        idTipoVisita: row?.idComboVisitaValorTipoVisitaNavigation?.idComboVisitaValor,
        visitasProgramadas: visitasProgramadas,
        periodo: periodo
      }
    });
  };

  const handleClickEdit = async (row) => {
    const tieneGeo = await tieneGeoHabilitada();
    if (!tieneGeo) {
      toast.error("Debe habilitar el permiso de ubicación en su navegador para editar una visita.", {
        duration: 4000
      });
      return;
    }
    navigate(`${NuevaVisitaPath}`, {
      state: {
        isNew: false,
        onlyView: false,
        idVisita: row?.idVisita,
        idPaciente: row?.idPaciente,
        idProfesional: row?.idProfesional,
        idTipoProfesional: row?.idTipoProfesional,
        idFiguraProfesional: row?.idFiguraProfesional,
        figuraProfesional: row?.figuraProfesional,
        idEvaluacion: row?.idEvaluacion,
        idTipoModulo: row?.idTipoModulo,
        idFrecuencia: row?.idFrecuencia,
        programa: row?.programa,
        idTipoVisita: row?.idComboVisitaValorTipoVisitaNavigation?.idComboVisitaValor,
        visitasProgramadas: visitasProgramadas,
        periodo: periodo
      }
    });
  };

  const handleClickDelete = (row) => {
    setOpenConfirmDelete({ row, open: true });
  }

  const handleCancelDelete = () => {
    setOpenConfirmDelete({ row: null, open: false });
  }

  const onConfirmDelete = async () => {
    const row = openConfirmDelete.row;
    setOpenConfirmDelete({ row: null, open: false });

    const p = deleteVisita({ variables: { idVisita: row?.idVisita } }).
      then(async ({ data }) => {
        if (!data?.deleteVisita) {
          // Rechazamos para que el toast dispare el estado "error"
          throw new Error('No se pudo eliminar la visita');
        }
        await handleSearch();
        return true; // opcional
      });

    toast.
      promise(p, {
        loading: 'Eliminando visita...',
        success: 'Visita eliminada correctamente!',
        error: 'Ha ocurrido un error al eliminar la visita.'
      }).
      catch(() => {

        // Evitamos "Uncaught (in promise)". El toast ya mostró el error.
      });
  };

  return {
    handleClickView,
    handleClickEdit,
    handleClickDelete,
    handleCancelDelete,
    onConfirmDelete,
    openConfirmDelete
  };
};